import React from 'react';
import '../template-file-css/document-file-template.css';


export const FWC_BhaAdult = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='FWC_BhaAdult' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <center>
                        <h3>
                            Family Wellness Center
                        </h3>
                        <h4>
                            Making a Difference, One Family at a Time.
                        </h4>
                        <h3>
                            3883 Rogers Bridge Rd. #202A
                        </h3>
                        <h3>
                            Duluth, GA 30097
                        </h3>
                        <h3>
                            770-545-8359
                        </h3>
                        <h3>
                            Adult Behavior Health Assessment
                        </h3>
                    </center>
                </p>

                <h3>
                    DEMOGRAPHIC INFORMATION <span className='small'>(Complete All Information)</span>
                </h3>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Individual Name:</span></td>
                        <td className='w-250'><span className='eleHeader'>Date of Service:</span></td>
                        <td className='w-250'><span className='eleHeader'>Assessor Name</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtIndividulName" name="txtIndividulName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtDateService12" name="txtDateService12" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAssessorName" name="txtAssessorName" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Parent/Guardian</span> <span className='small'>(If Applicable):</span></td>
                        <td className='w-250'><span className='eleHeader'>Home Telephone</span></td>
                        <td className='w-250'><span className='eleHeader'>Cell phone</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtParentGuardian" name="txtParentGuardian" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtHomeTelephone" name="txtHomeTelephone" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtCellPhone" name="txtCellPhone" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Address:</span></td>
                        <td className='w-250'><span className='eleHeader'>City</span></td>
                        <td className='w-250'><span className='eleHeader'>State</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtAddress" name="txtAddress" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtCity" name="txtCity" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtState" name="txtState" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Zip code</span></td>
                        <td className='w-250'><span className='eleHeader'>Individual DOB:</span></td>
                        <td className='w-250'><span className='eleHeader'>Age:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtZipCode" name="txtZipCode" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="date" id="txtIndividualDob" name="txtIndividualDob" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtAge" name="txtAge" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Race/Ethnicity:</span></td>
                        <td className='w-250'><span className='eleHeader'>Gender:</span></td>
                        <td className='w-250'><span className='eleHeader'>Sexual Identification:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtRaceEthnicity" name="txtRaceEthnicity" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbGender_Yes" name="rbGender" className='add-only' value="1" /> &nbsp; Male    &nbsp;&nbsp;
                            <input type="radio" id="rbGender_No" name="rbGender" className='add-only' value="0" /> &nbsp;Female
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSexualIdentification" name="txtSexualIdentification" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Gender Expression:</span></td>
                        <td className='w-250'><span className='eleHeader'>Religion:</span></td>
                        <td className='w-250'><span className='eleHeader'>Emergency Contact Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtGenderExpression" name="txtGenderExpression" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtReligion" name="txtReligion" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtEmergencyContact" name="txtEmergencyContact" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Relationship</span></td>
                        <td className='w-250'><span className='eleHeader'>Contact Telephone</span></td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="text" id="txtRelationship" name="txtRelationship" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtContactTelephone" name="txtContactTelephone" className='add-only' />
                        </td>
                        <td className='w-250'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className="eleHeader">Referral Source:</span>
                    <textarea id="txtReferralSource" name="txtReferralSource" className="add-only"></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>INSURANCE INFORMATION</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='checkbox' id='cbAmerigroup' name='cbAmerigroup' className='add-only' value='Amerigroup' /> Amerigroup: </td>
                        <td className='w-175'><input type="text" id="txtAmerigroup" name="txtAmerigroup" className='add-only' /></td>
                        <td className='w-200'><input type='checkbox' id='cbMedicaid' name='cbMedicaid' className='add-only' value='Medicaid' /> Medicaid:  </td>
                        <td className='w-175'><input type="text" id="txtMedicaid" name="txtMedicaid" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='checkbox' id='cbPeachstate' name='cbPeachstate' className='add-only' value='Peachstate' /> Peachstate: </td>
                        <td className='w-175'><input type="text" id="txtPeachstate" name="txtPeachstate" className='add-only' /></td>
                        <td className='w-200'><input type='checkbox' id='cbCenpatico' name='cbCenpatico' className='add-only' value='Cenpatico' /> Cenpatico: </td>
                        <td className='w-175'><input type="text" id="txtCenpatico" name="txtCenpatico" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='checkbox' id='cbCareSource' name='cbCareSource' className='add-only' value='CareSource' /> CareSource: </td>
                        <td className='w-175'><input type="text" id="txtCareSource" name="txtCareSource" className='add-only' /></td>
                        <td className='w-200'><input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='Other' /> Other: </td>
                        <td className='w-175'><input type="text" id="txtOther12" name="txtOther12" className='add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Location of assessment?</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="radio" id="rbLocationAssessment_Yes" name="rbLocationAssessment" className='add-only' value="1" /> &nbsp;Home </td>
                        <td className='w-250'><input type="radio" id="rbLocationAssessment_No" name="rbLocationAssessment" className='add-only' value="2" /> &nbsp; Office   </td>
                        <td className='w-250'><input type="radio" id="rbLocationAssessment_Ye" name="rbLocationAssessment" className='add-only' value="3" /> &nbsp; Telehealth  </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="radio" id="rbLocationAssessment_Ys" name="rbLocationAssessment" className='add-only' value="4" />&nbsp;Other
                            <input type="text" id="txtOtherHome" name="txtOtherHome" className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Who was present during assessment?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtPresent" name="txtPresent" className='add-only' />
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <h4>
                    INTERVIEW OBSERVATIONS
                </h4>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Appearance</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='checkbox' id='cbWell_1' name='cbWell_1' className='add-only' value='Well_1' /> Well groomed</td>
                        <td className='w-200'><input type='checkbox' id='cbWell_2' name='cbWell_2' className='add-only' value='Well_2' /> Unkempt</td>
                        <td className='w-175'><input type='checkbox' id='cbWell_3' name='cbWell_3' className='add-only' value='Well_3' /> Disheveled</td>
                        <td className='w-175'><input type='checkbox' id='cbWell_4' name='cbWell_4' className='add-only' value='Well_4' /> Malodorous</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Build</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='checkbox' id='cbWell_5' name='cbWell_5' className='add-only' value='Well_5' /> Average</td>
                        <td className='w-200'><input type='checkbox' id='cbWell_6' name='cbWell_6' className='add-only' value='Well_6' /> Thin</td>
                        <td className='w-175'><input type='checkbox' id='cbWell_7' name='cbWell_7' className='add-only' value='Well_7' /> Overweight</td>
                        <td className='w-175'><input type='checkbox' id='cbWell_8' name='cbWell_8' className='add-only' value='Well_8' /> Obese</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Demeanor</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='checkbox' id='cbWell_9' name='cbWell_9' className='add-only' value='Well_9' /> Cooperative</td>
                        <td className='w-200'><input type='checkbox' id='cbWell_10' name='cbWell_10' className='add-only' value='Well_10' /> Hostile</td>
                        <td className='w-175'><input type='checkbox' id='cbWell_11' name='cbWell_11' className='add-only' value='Well_11' /> Guarded</td>
                        <td className='w-175'><input type='checkbox' id='cbWell_12' name='cbWell_12' className='add-only' value='Well_12' /> Withdrawn</td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='checkbox' id='cbWell_13' name='cbWell_13' className='add-only' value='Well_13' /> Preoccupied</td>
                        <td className='w-200'><input type='checkbox' id='cbWell_14' name='cbWell_14' className='add-only' value='Well_14' /> Demanding</td>
                        <td className='w-175'><input type='checkbox' id='cbWell_15' name='cbWell_15' className='add-only' value='Well_15' /> Seductive</td>
                        <td className='w-175'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Eye Contact</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='checkbox' id='cbWell_16' name='cbWell_16' className='add-only' value='Well_16' /> Average</td>
                        <td className='w-200'><input type='checkbox' id='cbWell_17' name='cbWell_17' className='add-only' value='Well_17' /> Decreased</td>
                        <td className='w-175'><input type='checkbox' id='cbWell_18' name='cbWell_18' className='add-only' value='Well_18' /> Increased</td>
                        <td className='w-175'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Speech</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='checkbox' id='cbWell_19' name='cbWell_19' className='add-only' value='Well_19' /> Clear</td>
                        <td className='w-200'><input type='checkbox' id='cbWell_20' name='cbWell_20' className='add-only' value='Well_20' /> Slurred</td>
                        <td className='w-175'><input type='checkbox' id='cbWell_21' name='cbWell_21' className='add-only' value='Well_21' /> Rapid</td>
                        <td className='w-175'><input type='checkbox' id='cbWell_22' name='cbWell_22' className='add-only' value='Well_22' /> Slow</td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='checkbox' id='cbWell_23' name='cbWell_23' className='add-only' value='Well_23' /> Pressured</td>
                        <td className='w-200'><input type='checkbox' id='cbWell_24' name='cbWell_24' className='add-only' value='Well_24' /> Soft</td>
                        <td className='w-175'><input type='checkbox' id='cbWell_25' name='cbWell_25' className='add-only' value='Well_25' /> Loud</td>
                        <td className='w-175'><input type='checkbox' id='cbWell_26' name='cbWell_26' className='add-only' value='Well_26' /> Monotone</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className="eleHeader">Mental Status:</span>
                    <span className='small'>(Describe Individual mood, affect, thought processes, though contact, AVH, intelligence, insight, judgment, and orientation)</span>
                    <textarea id="txtMentalStatus" name="txtMentalStatus" className="add-only"></textarea>
                </p>
                <h3>
                    Progress section <span className='small'>(Only complete if this is an update/ongoing assessment)</span>
                </h3>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Progress since previous Service Plan: </span></td>
                    </tr>
                    <tr>
                        <td className='w-400'><input type='checkbox' id='cbProgress_1' name='cbProgress_1' className='add-only' value='Progress_1' /> N/A New Intake - Progress will be monitored   </td>
                        <td className='w-175'><input type='checkbox' id='cbProgress_2' name='cbProgress_2' className='add-only' value='Progress_2' /> Minimal Progress </td>
                        <td className='w-175'><input type='checkbox' id='cbProgress_3' name='cbProgress_3' className='add-only' value='Progress_3' /> Moderate Progress</td>
                    </tr>
                    <tr>
                        <td className='w-400'><input type='checkbox' id='cbProgress_4' name='cbProgress_4' className='add-only' value='Progress_4' />Significant Progress </td>
                        <td className='w-175'><input type='checkbox' id='cbProgress_5' name='cbProgress_5' className='add-only' value='Progress_5' /> Goal Accomplished </td>
                        <td className='w-175'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className="eleHeader">Progress Details:</span>
                    <span className='small'>(Record the progress made by the consumer and family in accomplishing the most recent treatment plan goals and objectives. Be sure to address each goal and objective for all treating staff, offering evidence for what was achieved)</span>
                    <textarea id="txtProgressDetails" name="txtProgressDetails" className="add-only"></textarea>
                </p>
                <h3>
                    PRESENTING PROBLEM/HISTORY OF PRESENTING PROBLEMS
                </h3>
                <p className='w-750'>
                    <span className="eleHeader">
                        What is the Individual's presenting problem/why are they here?
                    </span>
                    Please include the reason for referral, presenting problem, precipitating events, symptoms and behaviors that support the DSM-5 diagnosis. Must also include frequency, intensity, onset and duration of symptoms and behaviors.
                    <textarea id="txtPresentingProblem" name="txtPresentingProblem" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">History of presenting problems </span>
                    <span className='small'>(Behaviors, moods, emotions they exhibit  in the past and current)</span>
                    <textarea id="txtHistoryPresentingProblem" name="txtHistoryPresentingProblem" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Does consumer need any form of Technical Assistance (TA)? </span>
                    <span className='small'>(i.e. Braille, talking thermostat, text-to-speech systems, phone with captioning etc.)</span>
                    <input type="radio" id="rbBraille_Yes" name="rbBraille" className='add-only' value="1" />&nbsp;&nbsp;Yes&nbsp;&nbsp;
                    <input type="radio" id="rbBraille_No" name="rbBraille" className='add-only' value="0" />&nbsp;No
                </p>
                <p>
                    <h3>
                        BEHAVIORAL HEALTH SYMPTOMS
                    </h3>
                    <h4>
                        Please complete the below checklist for symptoms:
                    </h4>

                </p>
                <table>
                    <tr>
                        <td className='w-100'> <h4> Key: </h4> </td>
                        <td className='w-150'>
                            <br />
                            Severity Rating:
                            <ul>
                                <li>1=Mild</li>
                                <li>2=Moderate</li>
                                <li>3=Severe</li>
                            </ul>

                        </td>
                        <td className='w-250'>
                            <br />
                            Duration Rating:
                            <ul>
                                <li>1=Less than 1 Month</li>
                                <li>2=1 to 6 Months</li>
                                <li>3=7 to 11 Months</li>
                                <li>4=More than 1 Year</li>
                            </ul>

                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Symptom/Problem</span></td>
                        <td className='w-250'><span className='eleHeader'>Severity</span></td>
                        <td className='w-250'><span className='eleHeader'>Duration </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            1.	Anxiety
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_1" name="txtSeverity_1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_1" name="txtDuration_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            2.	Appetite Problems
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_2" name="txtSeverity_2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_2" name="txtDuration_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            3.	Bizarre Behavior
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_3" name="txtSeverity_3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_3" name="txtDuration_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            4.	Bizarre Ideations (Delusions)
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_4" name="txtSeverity_4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_4" name="txtDuration_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            5.	Conduct Problems
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_5" name="txtSeverity_5" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_5" name="txtDuration_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            6.	Depression
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_6" name="txtSeverity_6" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_6" name="txtDuration_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            7.	Eating Disorder
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_7" name="txtSeverity_7" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_7" name="txtDuration_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            8.	Family Problems
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_8" name="txtSeverity_8" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_8" name="txtDuration_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            9.	Gender Issues
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_9" name="txtSeverity_9" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_9" name="txtDuration_9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            10.	Impaired Memory
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_10" name="txtSeverity_10" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_10" name="txtDuration_10" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            11.	Indep. Living Problems
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_11" name="txtSeverity_11" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_11" name="txtDuration_11" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            12.	Lack of Support System
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_12" name="txtSeverity_12" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_12" name="txtDuration_12" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            13.	Loss of Energy
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_13" name="txtSeverity_13" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_13" name="txtDuration_13" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            14.	Loss of Interest
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_14" name="txtSeverity_14" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_14" name="txtDuration_14" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            15.	Obsessive/Compulsive
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_15" name="txtSeverity_15" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_15" name="txtDuration_15" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            16.	Panic Attacks
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_16" name="txtSeverity_16" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_16" name="txtDuration_16" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            17.	Paranoid Ideation
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_17" name="txtSeverity_17" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_17" name="txtDuration_17" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            18.	Phobia
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_18" name="txtSeverity_18" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_18" name="txtDuration_18" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            19.	Poor Interpersonal Skills
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_19" name="txtSeverity_19" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_19" name="txtDuration_19" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            20.	Poor Judgment
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_20" name="txtSeverity_20" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_20" name="txtDuration_20" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            21.	Poor Self Care Skills
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_21" name="txtSeverity_21" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_21" name="txtDuration_21" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            22.	School Problems
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_22" name="txtSeverity_22" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_22" name="txtDuration_22" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            23.	Sexual Acting Out
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_23" name="txtSeverity_23" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_23" name="txtDuration_23" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            24.	Sleep Problems
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_24" name="txtSeverity_24" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_24" name="txtDuration_24" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            25.	Somatization
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_25" name="txtSeverity_25" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_25" name="txtDuration_25" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            26.	Unusual Body Movements
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_26" name="txtSeverity_26" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_26" name="txtDuration_26" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            27.	Other
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_27" name="txtSeverity_27" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_27" name="txtDuration_27" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            28.	Other
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtSeverity_28" name="txtSeverity_28" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type="text" id="txtDuration_28" name="txtDuration_28" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className="eleHeader">If any of the above were checked, please provide specific details below. Please indicate frequency and intensity of symptoms. </span>
                    <span className='small'>(Please include historical information regarding diagnosis and symptoms as well as current presentation)</span>
                    <textarea id="txtHistoricalInformation" name="txtHistoricalInformation" className="add-only"></textarea>
                </p>
                <h4 className='w-750'>
                    FAMILY DYNAMICS: (COMPLETE ALL INFORMATION) Provide information on where the Individual was born, who they live with, any family separations or deaths, relationship with family members, how the Individual functions in their environment, significant relationships, history of trauma, and other relevant information pertaining to their social environment.
                </h4>
                <p className='w-750'>
                    <span className="eleHeader">Family History:</span>
                    <textarea id="txtFamilyHistory" name="txtFamilyHistory" className="add-only"></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Number of Children in household:</span></td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtHousehold" name="txtHousehold" className='add-only' />
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Individual living arrangements:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type="radio" id="rbLiving_Yes" name="rbLiving" className='add-only' value="1" /> &nbsp; Live alone  </td>
                        <td className='w-325'>
                            <input type="radio" id="rbLiving_No" name="rbLiving" className='add-only' value="2" /> &nbsp; Live with partner and/or children   </td>
                        <td className='w-325'>
                            <input type="radio" id="rbLiving_Ye" name="rbLiving" className='add-only' value="3" /> &nbsp; Live with parent/other family  </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type="radio" id="rbLiving_Ys" name="rbLiving" className='add-only' value="4" /> &nbsp; Homeless     </td>
                        <td className='w-325'>
                            <input type="radio" id="rbLiving_Na" name="rbLiving" className='add-only' value="5" /> &nbsp; Live w. roommate(s)     </td>
                        <td className='w-325'>
                            &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbLiving_Yeh" name="rbLiving" className='add-only' value="6" /> &nbsp; Other: &nbsp;
                            <input type="text" id="txtHouseholdOther" name="txtHouseholdOther" className='add-only w-250 custom-add-only' />

                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className="eleHeader">At Risk of Homelessness:   </span>
                    <input type="radio" id="rbRisk_Yes" name="rbRisk" className='add-only' value="1" />&nbsp;&nbsp;Yes or&nbsp;&nbsp;
                    <input type="radio" id="rbRisk_No" name="rbRisk" className='add-only' value="0" />&nbsp;No
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Individual work history:</span>
                    <textarea id="txtHistoryIndividual" name="txtHistoryIndividual" className="add-only"></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Source of Income:</span></td>
                        <td className='w-375'><span className='eleHeader'>Is Individual able to meet expenses? </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtSourceIncome" name="txtSourceIncome" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="radio" id="rbIndividual_Yes" name="rbIndividual" className='add-only' value="1" />&nbsp;&nbsp;Yes&nbsp;&nbsp;
                            <input type="radio" id="rbIndividual_No" name="rbIndividual" className='add-only' value="0" />&nbsp;No
                        </td>
                    </tr>
                </table>
                <h3>
                    FAMILY MEDICAL HISTORY
                </h3>
                <p className='w-750'>
                    <span className="eleHeader">Is there a family history of behavioral health or intellectual disability problems? </span>
                    <input type="radio" id="rbDisability_Yes" name="rbDisability" className='add-only' value="1" />&nbsp;&nbsp;Yes &nbsp;&nbsp;
                    <input type="radio" id="rbDisability_No" name="rbDisability" className='add-only' value="0" />&nbsp;No
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Provide details if yes: </span>
                    <textarea id="txtProvideDetails" name="txtProvideDetails" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Is there a family history of substance abuse? </span>
                    <input type="radio" id="rbDisability_1_Yes" name="rbDisability_1" className='add-only' value="1" />&nbsp;&nbsp;Yes &nbsp;&nbsp;
                    <input type="radio" id="rbDisability_1_No" name="rbDisability_1" className='add-only' value="0" />&nbsp;No
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Provide details if yes: </span>
                    <textarea id="txtProvideDetails_1" name="txtProvideDetails_1" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Family history of major health problems</span> <span className='small'>(example - hypertension, diabetes, cancer, morbid obesity. etc.)</span>
                    <input type="radio" id="rbDisability_2_Yes" name="rbDisability_2" className='add-only' value="1" />&nbsp;&nbsp;Yes &nbsp;&nbsp;
                    <input type="radio" id="rbDisability_2_No" name="rbDisability_2" className='add-only' value="0" />&nbsp;No
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Provide details if yes: </span>
                    <textarea id="txtProvideDetails_2" name="txtProvideDetails_2" className="add-only"></textarea>
                </p>
                <h3>
                    ACADEMIC HISTORY
                </h3>
                <p className='w-750'>
                    <span className="eleHeader">Highest grade level completed?</span>
                    <input type="radio" id="rbHighestGrade_Yes" name="rbHighestGrade" className='add-only' value="1" />&nbsp;&nbsp;Yes &nbsp;&nbsp;
                    <input type="radio" id="rbHighestGrade_No" name="rbHighestGrade" className='add-only' value="0" />&nbsp;No
                </p>
                <p className='w-750'>
                    <span className="eleHeader">History of behavior challenges in school?</span>
                    <input type="radio" id="rbHighestHistory_Yes" name="rbHistory" className='add-only' value="1" />&nbsp;&nbsp;Yes &nbsp;&nbsp;
                    <input type="radio" id="rbHighestHistory_No" name="rbHistory" className='add-only' value="0" />&nbsp;No
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Did the Individual have an IEP or in special classes?</span>
                    <input type="radio" id="rbSpecialClasses_Yes" name="rbSpecialClasses" className='add-only' value="1" />&nbsp;&nbsp;Yes &nbsp;&nbsp;
                    <input type="radio" id="rbSpecialClasses_No" name="rbSpecialClasses" className='add-only' value="0" />&nbsp;No
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Literacy Level: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbLiteracy_5' name='cbLiteracy_5' className='add-only' value='Literacy_5' /> Appropriate for age</td>
                        <td className='w-375'><input type='checkbox' id='cbLiteracy_6' name='cbLiteracy_6' className='add-only' value='Literacy_6' /> Defaulting reading or writing;</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className="eleHeader">Explain:</span>
                    <textarea id="txtExplain" name="txtExplain" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Literacy - Was Individual able to comprehend and answer questions appropriately? </span>
                    <input type="radio" id="rbLiteracy_Yes" name="rbLiteracy" className='add-only' value="1" />&nbsp;&nbsp;Yes &nbsp;&nbsp;
                    <input type="radio" id="rbLiteracy_No" name="rbLiteracy" className='add-only' value="0" />&nbsp;No
                </p>
                <h3>
                    MENTAL HEALTH HISTORY
                </h3>
                <p className='w-750'>
                    <span className="eleHeader">1.	Have you ever had counseling before? </span>
                    <input type="radio" id="rbLiteracy_1_Yes" name="rbLiteracy1" className='add-only' value="1" />&nbsp;&nbsp;No &nbsp;&nbsp;
                    <input type="radio" id="rbLiteracy_1_No" name="rbLiteracy1" className='add-only' value="0" />&nbsp;Yes If yes,
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>a. Providers Name & Contact Information: </span></td>
                        <td className='w-375'><span className='eleHeader'>b. Dates of Services Received: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtProvidersName" name="txtProvidersName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="date" id="txtDatesServices" name="txtDatesServices" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className="eleHeader">c.	Previous Diagnosis: </span>
                    <textarea id="txtPreviousDiagnosis" name="txtPreviousDiagnosis" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">d.	Have you ever been hospitalized for mental health?  </span>
                    <input type="radio" id="rbLiteracy_2_Yes" name="rbLiteracy2" className='add-only' value="1" />&nbsp;&nbsp;No &nbsp;&nbsp;
                    <input type="radio" id="rbLiteracy_2_No" name="rbLiteracy2" className='add-only' value="0" />&nbsp;Yes Provide details if yes:
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>e. Hospital Name & Contact Information:  </span></td>
                        <td className='w-375'><span className='eleHeader'>f. Dates Hospitalized:  </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtHospitalName" name="txtHospitalName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="date" id="txtDatesHospitalized" name="txtDatesHospitalized" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className="eleHeader">g. Previous Diagnosis and Reason for Hospitalization: </span>
                    <textarea id="txtPreviousDiagnosis_1" name="txtPreviousDiagnosis_1" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Are you involved with any complementary physical and/or psychological approaches? </span>
                    <span className='small'>(i.e tai chi, yoga, acupuncture, art therapy, dance therapy etc.?)</span>
                    <input type="radio" id="rbLiteracy_3_Yes" name="rbLiteracy3" className='add-only' value="1" />&nbsp;&nbsp;No &nbsp;&nbsp;
                    <input type="radio" id="rbLiteracy_3_No" name="rbLiteracy3" className='add-only' value="0" />&nbsp;Yes
                </p>
                <h3>
                    MEDICAL HISTORY
                </h3>
                <p className='w-750'>
                    <span className="eleHeader">Describe Individual's past/current medical history  </span>
                    <span className='small'>(include specific diagnosis, when diagnosed, and treatment) </span>
                    <textarea id="txtPreviousDiagnosis_2" name="txtPreviousDiagnosis_2" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Are you currently pregnant: </span>
                    <input type="radio" id="rbLiteracy_4_Yes" name="rbLiteracy4" className='add-only' value="1" />&nbsp;&nbsp;Yes&nbsp;&nbsp;
                    <input type="radio" id="rbLiteracy_4_No" name="rbLiteracy4" className='add-only' value="0" />&nbsp;No&nbsp;&nbsp;
                    <input type="radio" id="rbLiteracy_4_Ni" name="rbLiteracy4" className='add-only' value="2" />&nbsp;N/A
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Any previous pregnancies, miscarriages or abortions:</span>
                    <input type="radio" id="rbLiteracy_5_Yes" name="rbLiteracy5" className='add-only' value="1" />&nbsp;&nbsp;Yes&nbsp;&nbsp;
                    <input type="radio" id="rbLiteracy_5_No" name="rbLiteracy5" className='add-only' value="0" />&nbsp;No&nbsp;&nbsp;
                    <input type="radio" id="rbLiteracy_5_Ni" name="rbLiteracy5" className='add-only' value="2" />&nbsp;N/A
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Do you have any allergies </span>
                    <span className='small'> (medication/food/environmental) </span>
                    <input type="radio" id="rbLiteracy_6_Yes" name="rbLiteracy6" className='add-only' value="1" />&nbsp;&nbsp;Yes&nbsp;&nbsp;
                    <input type="radio" id="rbLiteracy_6_No" name="rbLiteracy6" className='add-only' value="0" />&nbsp;No If so,
                </p>
                <p className='w-750'>
                    <span className="eleHeader">please list allergies? </span>
                    <textarea id="txtPreviousDiagnosis_3" name="txtPreviousDiagnosis_3" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Primary Care Physician  </span>
                    <input type="radio" id="rbLiteracy_7_Yes" name="rbLiteracy7" className='add-only' value="1" />&nbsp;&nbsp;Yes&nbsp;&nbsp;
                    <input type="radio" id="rbLiteracy_7_No" name="rbLiteracy7" className='add-only' value="0" />&nbsp;No if yes,
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>PCP's name:  </span></td>
                        <td className='w-375'><span className='eleHeader'>PCP's number:  </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtPcpName" name="txtPcpName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtPcpNumber" name="txtPcpNumber" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Weight:  </span></td>
                        <td className='w-375'><span className='eleHeader'>Height:  </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtWeight1" name="txtWeight1" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="text" id="txtHeight1" name="txtHeight1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className="eleHeader">Immunization current   </span>
                    <input type="radio" id="rbLiteracy_8_Yes" name="rbLiteracy8" className='add-only' value="1" />&nbsp;&nbsp;Yes&nbsp;&nbsp;
                    <input type="radio" id="rbLiteracy_8_No" name="rbLiteracy8" className='add-only' value="0" />&nbsp;No
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Medical Problems:</span>
                    <textarea id="txtMedicalProblems" name="txtMedicalProblems" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Prescribed/Psychotropic medications: </span>
                    <textarea id="txtPrescribedPsychotropic" name="txtPrescribedPsychotropic" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">How are the medications working, describe any barriers? </span>
                    <textarea id="txtPrescribedPsychotropic_1" name="txtPrescribedPsychotropic_1" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Past medications:  </span>
                    <textarea id="txtPastMedications" name="txtPastMedications" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Over-the counter medications: </span>
                    <textarea id="txtPastOver" name="txtPastOver" className="add-only"></textarea>
                </p>
                <h4>
                    Any difficulties with language functioning including:
                </h4>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Speech:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_1' name='cbSpeech_1' className='add-only' value='Speech_1' /> WNL </td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_2' name='cbSpeech_2' className='add-only' value='Speech_2' /> Impaired </td>
                        <td className='w-250'><input type='checkbox' id='cbSpeech_3' name='cbSpeech_3' className='add-only' value='Speech_3' /> Needs follow-up  </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Hearing:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbHearing_1' name='cbHearing_1' className='add-only' value='Hearing_1' /> WNL </td>
                        <td className='w-250'><input type='checkbox' id='cbHearing_2' name='cbHearing_2' className='add-only' value='Hearing_2' /> Impaired </td>
                        <td className='w-250'><input type='checkbox' id='cbHearing_3' name='cbHearing_3' className='add-only' value='Hearing_3' /> Needs follow-up  </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Visual:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbVisual_1' name='cbVisual_1' className='add-only' value='Visual_1' /> WNL </td>
                        <td className='w-250'><input type='checkbox' id='cbVisual_2' name='cbVisual_2' className='add-only' value='Visual_2' /> Impaired </td>
                        <td className='w-250'><input type='checkbox' id='cbVisual_3' name='cbVisual_3' className='add-only' value='Visual_3' /> Needs follow-up  </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Other:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbSpeechOther_1' name='cbSpeechOther_1' className='add-only' value='SpeechOther_1' /> WNL </td>
                        <td className='w-250'><input type='checkbox' id='cbSpeechOther_2' name='cbSpeechOther_2' className='add-only' value='SpeechOther_2' /> Impaired </td>
                        <td className='w-250'><input type='checkbox' id='cbSpeechOther_3' name='cbSpeechOther_3' className='add-only' value='SpeechOther_3' /> Needs follow-up  </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className="eleHeader">Additional Medical Comments: </span>
                    <textarea id="txtAdditionalMedical" name="txtAdditionalMedical" className="add-only"></textarea>
                </p>
                <h3>
                    DEVELOPMENTAL HISTORY
                </h3>
                <p className='w-750'>
                    <span className="eleHeader">What was the Individual's health at birth?  </span>
                    <textarea id="txtIndividualHealth" name="txtIndividualHealth" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Did Individual have any problems with developmental milestones?</span>
                    <input type="radio" id="rbLiteracy_15_Yes" name="rbLiteracy15" className='add-only' value="1" />&nbsp;&nbsp;Yes&nbsp;&nbsp;
                    <input type="radio" id="rbLiteracy_15_No" name="rbLiteracy15" className='add-only' value="0" />&nbsp;No&nbsp;&nbsp;
                    <input type="radio" id="rbLiteracy_15_Ni" name="rbLiteracy15" className='add-only' value="2" />&nbsp;Unknown
                </p>
                <p className='w-750'>
                    <span className="eleHeader">If "yes" or "unknown" provide details: </span>
                    <textarea id="txtUnknown" name="txtUnknown" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">SUBSTANCE ABUSE ASSESSMENT: Have you had substance use/abuse now or in the past?</span>
                    <input type="radio" id="rbLiteracy_16_Yes" name="rbLiteracy16" className='add-only' value="1" />&nbsp;&nbsp;Yes&nbsp;&nbsp;
                    <input type="radio" id="rbLiteracy_16_No" name="rbLiteracy16" className='add-only' value="0" />&nbsp;No If yes, please answer the following:
                </p>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Substance Name </span></td>
                        <td className='w-100'><span className='eleHeader'>Age of 1st Use </span></td>
                        <td className='w-100'><span className='eleHeader'>Age of Heaviest Use </span></td>
                        <td className='w-150'><span className='eleHeader'>Frequency/Amount </span></td>
                        <td className='w-150'><span className='eleHeader'>Date of Last use</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Alcohol
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeFirstUse_1" name="txtAgeFirstUse_1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeHeaviestUse_1" name="txtAgeHeaviestUse_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequencyAmount_1" name="txtFrequencyAmount_1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast_1" name="txtDateLast_1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Cannabis
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeFirstUse_2" name="txtAgeFirstUse_2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeHeaviestUse_2" name="txtAgeHeaviestUse_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequencyAmount_2" name="txtFrequencyAmount_2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast_2" name="txtDateLast_2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Cocaine
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeFirstUse_3" name="txtAgeFirstUse_3" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeHeaviestUse_3" name="txtAgeHeaviestUse_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequencyAmount_3" name="txtFrequencyAmount_3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast_3" name="txtDateLast_3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Stimulants <span className='small'>(Crystal, speed, amphetamines)</span>
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeFirstUse_4" name="txtAgeFirstUse_4" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeHeaviestUse_4" name="txtAgeHeaviestUse_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequencyAmount_4" name="txtFrequencyAmount_4" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast_4" name="txtDateLast_4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Methamphetamine
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeFirstUse_5" name="txtAgeFirstUse_5" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeHeaviestUse_5" name="txtAgeHeaviestUse_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequencyAmount_5" name="txtFrequencyAmount_5" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast_5" name="txtDateLast_5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Inhalants  <span className='small'>(LSD, PCP, mushrooms)</span>
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeFirstUse_6" name="txtAgeFirstUse_6" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeHeaviestUse_6" name="txtAgeHeaviestUse_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequencyAmount_6" name="txtFrequencyAmount_6" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast_6" name="txtDateLast_6" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Opioids  <span className='small'>(Heroine, Narcotics, Methadone)</span>
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeFirstUse_7" name="txtAgeFirstUse_7" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeHeaviestUse_7" name="txtAgeHeaviestUse_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequencyAmount_7" name="txtFrequencyAmount_7" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast_7" name="txtDateLast_7" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Sedative/Hypnotics  <span className='small'>(Valium,  Xanax)</span>
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeFirstUse_8" name="txtAgeFirstUse_8" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeHeaviestUse_8" name="txtAgeHeaviestUse_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequencyAmount_8" name="txtFrequencyAmount_8" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast_8" name="txtDateLast_8" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Designer Drugs<span className='small'>(Herbal, Steroids, Cough Syrup)</span>
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeFirstUse_9" name="txtAgeFirstUse_9" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeHeaviestUse_9" name="txtAgeHeaviestUse_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequencyAmount_9" name="txtFrequencyAmount_9" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast_9" name="txtDateLast_9" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Tobacco
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeFirstUse_10" name="txtAgeFirstUse_10" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeHeaviestUse_10" name="txtAgeHeaviestUse_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequencyAmount_10" name="txtFrequencyAmount_10" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast_10" name="txtDateLast_10" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Other
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeFirstUse_11" name="txtAgeFirstUse_11" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type="text" id="txtAgeHeaviestUse_11" name="txtAgeHeaviestUse_11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="text" id="txtFrequencyAmount_11" name="txtFrequencyAmount_11" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type="date" id="txtDateLast_11" name="txtDateLast_11" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className="eleHeader">What consequences has the Individual faced as a result of the Drug/Alcohol use? </span>
                    <span className='small'>(Include hangovers, DT's, Blackouts, Binges, Overdoses, Seizures, GI Bleeding, Job Loss, DUI's, Assaults, Incarcerations, Homicides, etc)</span>
                    <textarea id="txtHangovers" name="txtHangovers" className="add-only"></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Longest period of sobriety? </span></td>
                        <td className='w-375'><span className='eleHeader'>When?  </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtLongestPeriod" name="txtLongestPeriod" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="date" id="txtWhen" name="txtWhen" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>
                    SUICIDE/HOMICIDE RISK POTENTIAL
                </h3>
                <p className='w-750'>
                    <span className="eleHeader">Have you had any suicidal or homicidal thoughts now or in the past?</span>
                    <input type="radio" id="rbHomicidal_Yes" name="rbHomicidal" className='add-only' value="1" />&nbsp;&nbsp;Yes   &nbsp;&nbsp;
                    <input type="radio" id="rbHomicidal_No" name="rbHomicidal" className='add-only' value="0" />&nbsp;No If yes, please answer the following:
                </p>
                <p className='w-750'>
                    <span className="eleHeader">1.	When and what triggered these thoughts?   </span>
                    <textarea id="txtTriggered" name="txtTriggered" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">2.	Are you having any thoughts now? </span>
                    <input type="radio" id="rbHomicidal_1_Yes" name="rbHomicidal_1" className='add-only' value="1" />&nbsp;&nbsp;Yes  &nbsp;&nbsp;
                    <input type="radio" id="rbHomicidal_1_No" name="rbHomicidal_1" className='add-only' value="0" />&nbsp;No
                </p>
                <p className='w-750'>
                    <span className="eleHeader">3.	When is the last time you had any suicidal thoughts? </span>
                    <textarea id="txtSuicidal" name="txtSuicidal" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">4.	When and what triggered those thoughts?  </span>
                    <textarea id="txtSuicidal_1" name="txtSuicidal_1" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">5.	How often do you have these thoughts?  </span>
                    <textarea id="txtSuicidal_2" name="txtSuicidal_2" className="add-only"></textarea>
                </p>
                <h3>
                    TRAUMA HISTORY
                </h3>
                <p className='w-750'>
                    <span className="eleHeader">1.	Have you ever been mentally, physically or sexually abused? </span>
                    <input type="radio" id="rbPhysically_Yes" name="rbPhysically" className='add-only' value="1" />&nbsp;&nbsp;Yes   &nbsp;&nbsp;
                    <input type="radio" id="rbPhysically_No" name="rbPhysically" className='add-only' value="0" />&nbsp;No If Yes or you have suspicions, please provide more details:
                    <textarea id="txtSuicidal_3" name="txtSuicidal_3" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">2.	Have you ever mentally, physically or sexually abused someone else?   </span>
                    <input type="radio" id="rbPhysically_1_Yes" name="rbPhysically_1" className='add-only' value="1" />&nbsp;&nbsp;Yes  &nbsp;&nbsp;
                    <input type="radio" id="rbPhysically_1_No" name="rbPhysically_1" className='add-only' value="0" />&nbsp;No/Unsure  If Yes or you have suspicions, please provide more details:
                    <textarea id="txtSuicidal_4" name="txtSuicidal_4" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">3.	Have you even been exposed to domestic violence? </span>
                    <input type="radio" id="rbPhysically_2_Yes" name="rbPhysically_2" className='add-only' value="1" />&nbsp;&nbsp;Yes  &nbsp;&nbsp;
                    <input type="radio" id="rbPhysically_2_No" name="rbPhysically_2" className='add-only' value="0" />&nbsp;No If Yes provide details:
                    <textarea id="txtSuicidal_5" name="txtSuicidal_5" className="add-only"></textarea>
                </p>
                <h3>
                    LEGAL HISTORY
                </h3>
                <p className='w-750'>
                    <span className="eleHeader">1.	Has the Individual ever been detained for domestic violence, DUI, drugs or any other criminal activity?  </span>
                    <input type="radio" id="rbPhysically_3_Yes" name="rbPhysically_3" className='add-only' value="1" />&nbsp;&nbsp;Yes &nbsp;&nbsp;
                    <input type="radio" id="rbPhysically_3_No" name="rbPhysically_3" className='add-only' value="0" />&nbsp;No If yes, Charge(s) & Date(s):
                    <textarea id="txtSuicidal_6" name="txtSuicidal_6" className="add-only"></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className="eleHeader">2. Legal Custody:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="radio" id="rbLegalRating_Yes" name="rbLegalRating" className='add-only' value="1" /> &nbsp;DFCS    </td>
                        <td className='w-250'><input type="radio" id="rbLegalRating_No" name="rbLegalRating" className='add-only' value="2" /> &nbsp; Parent   </td>
                        <td className='w-250'><input type="radio" id="rbLegalRating_Ye" name="rbLegalRating" className='add-only' value="3" /> &nbsp; Relative   </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type="radio" id="rbLegalRating_Ys" name="rbLegalRating" className='add-only' value="4" /> &nbsp;Other        </td>
                        <td className='w-250'>&nbsp; </td>
                        <td className='w-250'>&nbsp;   </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type="text" id="txtLegalRatingOther" name="txtLegalRatingOther" className='add-only' /> </td>
                        <td className='w-250'>&nbsp; </td>
                        <td className='w-250'>&nbsp;   </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className="eleHeader">3. Probation:  </span>
                    <input type="radio" id="rbPhysically_4_Yes" name="rbPhysically_4" className='add-only' value="1" />&nbsp;&nbsp;Yes &nbsp;&nbsp;
                    <input type="radio" id="rbPhysically_4_No" name="rbPhysically_4" className='add-only' value="0" />&nbsp;No If yes, please provide PO contact information:
                    <textarea id="txtSuicidal_7" name="txtSuicidal_7" className="add-only"></textarea>
                </p>
                <h3>
                    MILITARY HISTORY
                </h3>
                <p className='w-750'>
                    <span className="eleHeader">1.	Have you ever been in the military?  </span>
                    <input type="radio" id="rbPhysically_5_Yes" name="rbPhysically_5" className='add-only' value="1" />&nbsp;&nbsp;Yes   &nbsp;&nbsp;
                    <input type="radio" id="rbPhysically_5_No" name="rbPhysically_5" className='add-only' value="0" />&nbsp;No   If yes, please complete the questions below.
                    <textarea id="txtSuicidal_8" name="txtSuicidal_8" className="add-only"></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>2. What Branch?</span></td>
                        <td className='w-375'><span className='eleHeader'>3. Dates of service?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtWhatBranch" name="txtWhatBranch" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="date" id="txtWhenDates" name="txtWhenDates" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className="eleHeader">4.	Did you participate in combat? </span>
                    <input type="radio" id="rbPhysically_6_Yes" name="rbPhysically_6" className='add-only' value="1" />&nbsp;&nbsp;Yes  &nbsp;&nbsp;
                    <input type="radio" id="rbPhysically_6_No" name="rbPhysically_6" className='add-only' value="0" />&nbsp;No
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>5. Highest Rank? </span></td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtHighestRank" name="txtHighestRank" className='add-only' />
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className="eleHeader">6. Reason for Discharge? </span>
                    <textarea id="txtReasonDischarge" name="txtReasonDischarge" className="add-only"></textarea>
                </p>
                <h3>
                    SNAP (Strengths, Needs, Abilities, and Preferences)- in consumer's own words
                </h3>
                <p className='w-750'>
                    <span className="eleHeader">Strengths:</span>
                    <textarea id="txtStrengths" name="txtStrengths" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Needs:</span>
                    <textarea id="txtNeeds" name="txtNeeds" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Abilities:</span>
                    <textarea id="txtAbilities" name="txtAbilities" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Preferences:</span>
                    <textarea id="txtPreferences" name="txtPreferences" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Hopes:</span>
                    <textarea id="txtHopes" name="txtHopes" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Interpretative Summary:</span>
                    <span className='small'>(Provide a clinical summary of the assessment, to include evidence for DX, recommended service with frequencies and explanation of prognosis for recovery): </span>
                    <textarea id="txtInterpretativeSummary" name="txtInterpretativeSummary" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Recommendation of Services:</span>
                    <span className='small'>(What services would the Individual benefit from and how will they benefit the Individual): </span>
                    <textarea id="txtRecommendationServices" name="txtRecommendationServices" className="add-only"></textarea>
                </p>
                <h4>
                    Service Recommendations based upon initial assessment:
                </h4>
                <p className='w-750'>
                    <ul>
                        <li>
                            <input type='checkbox' id='cbRegistration' name='cbRegistration' className='add-only' value='cbRegistration' />  &nbsp; Registration (Further Assessment Needed along with immediate stabilization)
                        </li>
                        <li>
                            <input type='checkbox' id='cbIndividual' name='cbIndividual' className='add-only' value='Individual' /> &nbsp;  NIOP (Individual has met criteria for ongoing services & has verified diagnosis from M.D or Psychologist)
                        </li>
                        <li>
                            <input type='checkbox' id='cbIntensiveOutpatient' name='cbIntensiveOutpatient' className='add-only' value='Outpatient' /> &nbsp;	Intensive Outpatient (Individual has met criteria for intensive outpatient services & has verified diagnosis from M.D or Psychologist)
                        </li>
                        <li>
                            <input type='checkbox' id='cbStabilization' name='cbStabilization' className='add-only' value='Stabilization' /> &nbsp; Crises Stabilization
                        </li>
                        <li>
                            <input type='checkbox' id='cbHospitalization' name='cbHospitalization' className='add-only' value='Hospitalization' /> &nbsp; Hospitalization
                        </li>
                        <li>
                            <input type='checkbox' id='cbHospitalizationOther' name='cbHospitalizationOther' className='add-only' value='HospitalizationOther' /> &nbsp; Other:
                            <input type="text" id="txtHighestRankOther" name="txtHighestRankOther" className='add-only' />
                        </li>
                    </ul>
                </p>
                <h4>
                    Diagnostic Impression/ Diagnosis: ICD-10 Codes Included
                </h4>
                <p className='w-750'>
                    <span className="eleHeader">Primary:</span>
                    <textarea id="txtPrimary" name="txtPrimary" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Secondary:</span>
                    <textarea id="txtSecondary" name="txtSecondary" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Medical:</span>
                    <textarea id="txtMedical" name="txtMedical" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className="eleHeader">Environmental:</span>
                    <textarea id="txtEnvironmental" name="txtEnvironmental" className="add-only"></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Anticipated Discharge Date:</span></td>
                        <td className='w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="date" id="txtAnticipatedDischargeDate" name="txtAnticipatedDischargeDate" className='add-only' />
                        </td>
                        <td className='w-375'>
                            &nbsp;
                        </td>
                    </tr>
                </table>
                
                <p className='w-750'>
                    <span className="eleHeader">Discharge Plans and Transitional Considerations</span>
                    <span className='small'>(What changes does the Individual need to make, put this in the Individual's own words. When will the Individual be ready for discharge? List any barriers to treatment. Provide a community resource to support the gains made during program participation. Provide recommendation for continuity of the Individual's medication regime, if applicable):  </span>
                    <textarea id="txtDischargePlans" name="txtDischargePlans" className="add-only"></textarea>
                </p> 
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Print/Sign Provider Name and Credentials	 </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'> Print/Sign Supervisor Name and Credentials, If Applicable	 </td>
                        <td className='small w-250'> Date </td>
                    </tr>
                </table>





            </div>
        </form>

    )
}